<template>
  <div class="wrapper">
    <el-dialog
      :title="rowId ? '编辑商户' : '新增商户'"
      :visible.sync="showAddOrEdit"
      width="900px"
      :before-close="cancelFun"
      class="merchant-dialog"
    >
      <div class="scroll-wrap">
        <el-form ref="form" :model="formData" class="merchant-form" label-width="130px">
          <el-form-item label="商户名称" prop="merchantName" :rules="rules">
            <el-input 
              v-model="formData.merchantName" 
              placeholder="请输入商户名称"
              class="form-input"
            ></el-input>
          </el-form-item>
          <el-form-item label="企业名称" :rules="rules">
            <el-input 
              v-model="formData.companyName" 
              placeholder="请输入企业名称"
              class="form-input"
            ></el-input>
          </el-form-item>
          <el-form-item label="企业证件号" :rules="rules">
            <el-input 
              v-model="formData.companyIdentity" 
              placeholder="请输入企业证件号"
              class="form-input"
            ></el-input>
          </el-form-item>
          <el-form-item label="营业执照" :rules="rules">
            <FileUpload :isMulti="true" :name.sync="formData.companyLicenseList" :url="formData.companyLicenseUrlList"></FileUpload>
          </el-form-item>
          <el-form-item label="企业地址" :rules="rules">
            <el-input 
              v-model="formData.companyAddress" 
              placeholder="请输入企业地址"
              class="form-input"
            ></el-input>
          </el-form-item>
          <el-form-item label="法人姓名" :rules="rules">
            <el-input 
              v-model="formData.legalName" 
              placeholder="请输入法人姓名"
              class="form-input"
            ></el-input>
          </el-form-item>
          <el-form-item label="法人手机号" :rules="rules">
            <el-input 
              v-model="formData.legalMobile" 
              placeholder="请输入法人手机号"
              class="form-input"
            ></el-input>
          </el-form-item>
          <el-form-item label="法人身份证" :rules="rules">
            <el-input 
              v-model="formData.legalIdentity" 
              placeholder="请输入法人身份证"
              class="form-input"
            ></el-input>
          </el-form-item>
          <el-form-item :rules="rules" class="idcard-container">
            <div class="idcard-wrapper">
              <FileUpload class="idcard-uploader" :name.sync="formData.legalIdentityFrontImage" :url="formData.legalIdentityFrontImageUrl">
                身份证人像面
              </FileUpload>
              <FileUpload class="idcard-uploader" :name.sync="formData.legalIdentityBackImage" :url="formData.legalIdentityBackImageUrl">
                身份证国徽面
              </FileUpload>
            </div>
          </el-form-item>
          <el-form-item label="印章ID" :rules="rules">
            <el-input 
              v-model="formData.esignSealId" 
              placeholder="请输入印章ID"
              class="form-input"
            ></el-input>
          </el-form-item>
          <el-form-item label="分配比例" :rules="rules">
            <el-input 
              v-model="formData.allocateRate" 
              placeholder="请输入分配比例"
              class="form-input"
            ></el-input>
            <span class="form-tip">单位：%</span>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelFun">取 消</el-button>
        <el-button type="primary" size="small" @click="submitFun">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FileUpload from '@/components/file-upload/index.vue';
import { addMerchantAPI, getMerchantDetailAPI, editMerchantAPI } from './api';

export default {
  name: 'MerchantAddOrEdit',
  components: { FileUpload },
  props: {
    showAddOrEdit: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      rules: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
      formData: {
        merchantName: '',
        companyName: '',
        companyIdentity: '',
        companyLicenseList: [],
        companyLicenseUrlList: [],
        alipayAccount: '',
        legalName: '',
        legalMobile: '',
        legalEmail: '',
        legalIdentity: '',
        allocateRate: '',
        companyAddress: '',
        esignSealId: '',
      },
      fileList: [],
    }
  },
  mounted() {
    if (this.rowId) this.getMerchantDetail();
  },
  methods: {
    async getMerchantDetail() {
      this.formData = await getMerchantDetailAPI(this.rowId);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    submitFun() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.formData.id) {
            editMerchantAPI(this.formData).then(() => {
              this.$message.success('编辑成功');
              this.$emit("closeDialog", true);
            })
          } else {
            addMerchantAPI(this.formData).then(() => {
              this.$message.success('新增成功');
              this.$emit("closeDialog", true);
            })
          }
        }
      })
    },
    cancelFun() {
      this.$emit("closeDialog");
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
}

.merchant-dialog {
  ::v-deep .el-dialog {
    border-radius: 8px;
    overflow: hidden;
  }

  ::v-deep .el-dialog__header {
    background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
    padding: 20px 24px;
    border-bottom: none;

    .el-dialog__title {
      color: #fff;
      font-size: 18px;
      font-weight: 600;
    }

    .el-dialog__close {
      color: #fff;
      font-size: 20px;

      &:hover {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }

  ::v-deep .el-dialog__body {
    padding: 24px;
    background: #f5f7fa;
  }

  ::v-deep .el-dialog__footer {
    padding: 16px 24px;
    background: #fff;
    border-top: 1px solid #e4e7ed;
  }

  ::v-deep .el-form-item__label {
    font-weight: 500;
    color: #606266;
    font-size: 14px;
  }

  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }
}

.scroll-wrap {
  max-height: 65vh;
  overflow-y: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;

    &:hover {
      background: #a8a8a8;
    }
  }
}

.merchant-form {
  .form-input {
    width: 100%;
    max-width: 400px;

    ::v-deep .el-input__inner {
      border-radius: 4px;
      transition: all 0.3s ease;
      text-align: left;

      &:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
      }

      &:hover {
        border-color: #c0c4cc;
      }
    }
  }

  .form-tip {
    margin-left: 12px;
    font-size: 12px;
    color: #909399;
  }

  .idcard-wrapper {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
  }

  .idcard-container {
    .el-form-item__label {
      display: none;
    }
  }
}

.idcard-container {
  ::v-deep {
    .el-form-item__content {
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
    }
  }

  .idcard-uploader {
    flex: 1;
    min-width: 250px;
    
    ::v-deep .el-upload {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      min-width: 250px;
      height: 150px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      transition: all 0.3s ease;
      background: #fafbfc;
      
      &:hover {
        border-color: #409EFF;
        background: #f5f7fa;
      }
    }
    
    ::v-deep .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      transition: all 0.3s ease;
      
      &:hover {
        color: #409EFF;
      }
    }
    
    ::v-deep .avatar {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 6px;
      transition: all 0.3s ease;
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  .el-button {
    padding: 10px 24px;
    border-radius: 4px;
    font-weight: 500;
    transition: all 0.3s ease;

    &.el-button--primary {
      background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
      border: none;

      &:hover {
        background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
        box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
        transform: translateY(-2px);
      }
    }

    &:not(.el-button--primary) {
      &:hover {
        color: #409EFF;
        border-color: #409EFF;
        background-color: #ecf5ff;
      }
    }
  }
}

// 文件上传组件样式
.wrapper ::v-deep {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      border-color: #409EFF;
      background: #f5f7fa;
    }
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
  }

  .avatar {
    width: 148px;
    height: 148px;
    display: block;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .merchant-dialog {
    ::v-deep .el-dialog {
      width: 95% !important;
      margin: 5vh auto;
    }
  }

  .form-input {
    max-width: 100% !important;
  }

  .idcard-wrapper {
    flex-direction: column;
    
    .idcard-uploader {
      min-width: 100% !important;
    }
  }
}
</style>
